<template>
  <div class="popup" id="trackers">
    <div @click="close()" class="close-popup">
      <font-awesome-icon icon="times"></font-awesome-icon>
    </div>
    <ul v-if="trackers">
      <li :class="isActive(i)" v-for="(item, i) in trackers" :key="i">
        <h3 @click="$router.push('/trackers/' + item.id)">
          <font-awesome-icon :style="{color : item.color}" icon="arrow-right" />
          <span>
            {{item.name}}
          </span>
        </h3>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    trackers: {
      default: null,
      type: Array
    }
  },
  methods: {
    close() {
      document.getElementById("trackers").classList.remove("active");
    },
    isActive(i) {
      return i === parseInt(1) ? "active" : "";
    }
  },
  mounted() {}
};
</script>

<style lang="scss">
#trackers {
  .close-popup {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    color: #c0392b;
  }
  ul {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    > li {
      flex: 0 0 auto;
      width: 20%;
      min-width: 280px;
      padding: 1em;
      border-right: 1px dotted #e4e4e4;
      &:last-child {
        border-right: none;
      }
      h3 {
        padding: 1em 0;
        padding-top: 0;
        text-transform: uppercase;
        font-size: 0.9rem;
        display: flex;
        cursor: pointer;

        svg {
          font-size: 20px;
          margin-right: 10px;
        }
        span {
          line-height: 1.4;
        }
      }
      p {
        font-size: 0.8rem;
        color: #444;
        line-height: 1.5;
        letter-spacing: 0;
      }
      &.active {
        h3 {
          font-weight: bold;
        }
      }
    }
  }
}
@media screen and (max-width: 800px) {
  #trackers ul {
    display: block;
    > li {
      border-right: none;
      h3 {
        font-size: 0.85rem;
        padding: 0.5em 0;
      }
    }
  }
}
</style>
